import type { JSX } from 'react';
import { useT } from '../i18n/index.js';
import { socket } from '../net/socket.js';
import { useApp } from '../state/store.js';
import { Icon } from './Icon.js';
import './ConnectionBanner.css';

/**
 * Reconnect surface for the 60s grace window (PRD §8). The copy is fixed by
 * design spec §7.2 — the player has to know the seat is being held, not lost.
 *
 * A takeover gets its own message because it is a different fact: nothing
 * dropped, the account is being played on another screen. Saying "you lost
 * signal" and then racing that screen for the socket is exactly what made two
 * tabs flap at each other once a second.
 */
export function ConnectionBanner(): JSX.Element | null {
  const status = useApp((s) => s.status);
  const t = useT();
  if (status !== 'reconnecting' && status !== 'closed' && status !== 'superseded') return null;

  return (
    <div className="conn-banner" role="status" aria-live="polite" data-state={status}>
      <div className="conn-banner__inner">
        <Icon name="signal" size={16} className="conn-banner__icon" />
        {t(`conn.${status}`)}
        {status === 'superseded' ? (
          <button className="conn-banner__take" type="button" onClick={() => socket.resume()}>
            {t('conn.take')}
          </button>
        ) : null}
      </div>
    </div>
  );
}
